import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isNumber, isObject } from "../../../../Utils/Utils";
import { MoveAngle } from "./MoveAngle";
import { MoveAttract } from "./MoveAttract";
import { MoveCenter } from "./MoveCenter";
import { MoveGravity } from "./MoveGravity";
import { MovePath } from "./Path/MovePath";
import { MoveTrail } from "./MoveTrail";
import { OutModes } from "./OutModes";
import { Spin } from "./Spin";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Move = /*#__PURE__*/function () {
  function Move() {
    _classCallCheck(this, Move);

    this.angle = new MoveAngle();
    this.attract = new MoveAttract();
    this.center = new MoveCenter();
    this.decay = 0;
    this.distance = {};
    this.direction = "none";
    this.drift = 0;
    this.enable = false;
    this.gravity = new MoveGravity();
    this.path = new MovePath();
    this.outModes = new OutModes();
    this.random = false;
    this.size = false;
    this.speed = 2;
    this.spin = new Spin();
    this.straight = false;
    this.trail = new MoveTrail();
    this.vibrate = false;
    this.warp = false;
  }

  _createClass(Move, [{
    key: "bounce",
    get: function get() {
      return this.collisions;
    },
    set: function set(value) {
      this.collisions = value;
    }
  }, {
    key: "collisions",
    get: function get() {
      return false;
    },
    set: function set(_) {}
  }, {
    key: "noise",
    get: function get() {
      return this.path;
    },
    set: function set(value) {
      this.path = value;
    }
  }, {
    key: "outMode",
    get: function get() {
      return this.outModes.default;
    },
    set: function set(value) {
      this.outModes.default = value;
    }
  }, {
    key: "out_mode",
    get: function get() {
      return this.outMode;
    },
    set: function set(value) {
      this.outMode = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _ref, _data$outModes, _data$path;

      if (!data) {
        return;
      }

      this.angle.load(isNumber(data.angle) ? {
        value: data.angle
      } : data.angle);
      this.attract.load(data.attract);
      this.center.load(data.center);

      if (data.decay !== undefined) {
        this.decay = setRangeValue(data.decay);
      }

      if (data.direction !== undefined) {
        this.direction = data.direction;
      }

      if (data.distance !== undefined) {
        this.distance = isNumber(data.distance) ? {
          horizontal: data.distance,
          vertical: data.distance
        } : _objectSpread({}, data.distance);
      }

      if (data.drift !== undefined) {
        this.drift = setRangeValue(data.drift);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      this.gravity.load(data.gravity);
      var outModes = (_ref = (_data$outModes = data.outModes) !== null && _data$outModes !== void 0 ? _data$outModes : data.outMode) !== null && _ref !== void 0 ? _ref : data.out_mode;

      if (outModes !== undefined) {
        if (isObject(outModes)) {
          this.outModes.load(outModes);
        } else {
          this.outModes.load({
            default: outModes
          });
        }
      }

      this.path.load((_data$path = data.path) !== null && _data$path !== void 0 ? _data$path : data.noise);

      if (data.random !== undefined) {
        this.random = data.random;
      }

      if (data.size !== undefined) {
        this.size = data.size;
      }

      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }

      this.spin.load(data.spin);

      if (data.straight !== undefined) {
        this.straight = data.straight;
      }

      this.trail.load(data.trail);

      if (data.vibrate !== undefined) {
        this.vibrate = data.vibrate;
      }

      if (data.warp !== undefined) {
        this.warp = data.warp;
      }
    }
  }]);

  return Move;
}();